import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class NotLoggedInUsersGuard implements CanActivate {

  constructor(private authService: AuthService, protected router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let activate = !this.authService.isLoggedIn(true) || this.authService.requires2FA();
    if (!activate) {
      console.log('No se puede navegar a pagina de login, usuario logeado', route, state);
      this.router.navigate(['mainView']);
    }
    return of(activate);
  }

}
